import { render, staticRenderFns } from "./ru.vue?vue&type=template&id=f204033a&scoped=true&"
import script from "./ru.vue?vue&type=script&lang=ts&"
export * from "./ru.vue?vue&type=script&lang=ts&"
import style0 from "./ru.vue?vue&type=style&index=0&id=f204033a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f204033a",
  null
  
)

export default component.exports